import { CloseOutlined } from "@ant-design/icons";
import { Modal, DatePicker, Form, message, Button } from "antd";
import { useState, useEffect } from "react";
import { serverFetch } from "../../server";
import dayjs from "dayjs";
import { isMobile } from "../../extensions/design";
import { strDate2Server } from "../../extensions/utils"
import { CLIENT_NESTED_ANTD_MODAL_Z_INDEX } from "./client-nested-modal-zindex";

const CloseModal = ({ saleId, onClose }) => {
  const [form] = Form.useForm();
  const [date, setDate] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const today = dayjs();
    setDate(today);
    form.setFieldsValue({ dateEnd: today });
  }, []);

  const onStatusClosed = () => {
    const values = form.getFieldsValue();
    const dateStr = strDate2Server(values.dateEnd)
    setLoading(true);
    const bodyData = Array.isArray(saleId)
      ? { saleIds: saleId, date: dateStr }
      : { saleId, date: dateStr };
    serverFetch("sale/SetClosed", {
      method: "POST",
      bodyData,
    })
      .then((res) => {
        setLoading(false);
        const payload = res?.errors ?? res?.results ?? res;
        onClose(true, payload);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  return !isMobile ?
    <Modal
      title="Закрыть абонемент"
      open
      zIndex={CLIENT_NESTED_ANTD_MODAL_Z_INDEX}
      onCancel={() => onClose(false)}
      onOk={onStatusClosed}
      okText="Сохранить"
      cancelText="Закрыть"
      width={400}
    >
      <Form form={form} colon={false}>
        <Form.Item label="Дата закрытия" name="dateEnd">
          <DatePicker
            value={date}
            onChange={(date) => {
              setDate(date);
              form.setFieldsValue({ dateEnd: date });
            }}
            style={{ width: "100%" }}
            format="DD.MM.YYYY"
          />
        </Form.Item>
      </Form>
    </Modal>
  : <div className="sport-modal">
  <div className="sport-modal-overlay">
    <div className="sport-modal-content">
      <div className="sport-modal-title">
        <span>Закрыть абонемент</span>
        <CloseOutlined
          className="sport-section-title-close client-close-outlined-button-style" onClick={() => onClose(false)}             
        />
      </div>
      <Form form={form} labelCol={{ xs: 9}} wrapperCol={{ xs: 15}} colon={false} layout="inline">
          
        <Form.Item className="client-abon-form-item" label="Дата закрытия" name="dateEnd">
            <DatePicker className="client-abon-form-item" value={date} format="DD.MM.YYYY"
              onChange={(date) => {
                setDate(date);
                form.setFieldsValue({ dateEnd: date });
              }}
            />
          </Form.Item>
          <Button className="client-abon-form-item-with-margin" onClick={onStatusClosed}>Сохранить</Button>
        </Form>
      </div>
    </div>
  </div>
};

export default CloseModal;
